import { useaxios } from "../../../utils/useaxios";
export default (from, to) => initDispatch => clear => settype => {
    useaxios('report/summary/ledger.php', { from, to }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setledger_report', payload: res.ledger });
            settype('ledger_report');
            // setrecaller(recaller + 1);
        }
    });
}